export default __webpack_public_path__ + "static/media/Shadrack kamwenge.040ff114.JPG";